<template>
    <transition name="fade" mode="out-in">
        <div class="fixed inset-0  bg-black/40 flex justify-center items-center h-screen z-10">
            <div class="loader"></div>
        </div>
    </transition>
</template>



<style scoped>
.loader {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}


</style>